import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Bonos() {
  const revealRef = useScrollReveal();
  const gridRef = useScrollReveal();
  return <section id="bonos" className="bg-gris-oscuro py-14 sm:py-[90px] px-6" data-id="element-68">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-69">
        <div className="text-center" data-id="element-70">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-71">
            Apilamiento de valor
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-72">
            3 bonos que multiplican
            <br data-id="element-73" />
            lo que ya es una ganga
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-74"></div>
          <p className="text-[15px] text-white/60 max-w-[560px] mx-auto" data-id="element-75">
            Solo por comprar hoy, antes de que cierre este precio de
            lanzamiento, recibes estos 3 recursos sin costo adicional.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-7 mt-14 stagger-children" data-id="element-76">
          <div className="bg-carbon border border-oro/15 rounded-md overflow-hidden relative transition-all duration-300 hover:-translate-y-1.5 hover:border-oro/50" data-id="element-77">
            <span className="absolute top-3 right-3 bg-verde text-white font-montserrat font-black text-[11px] tracking-[1px] px-2.5 py-1 rounded-sm z-10" data-id="element-78">
              HOY GRATIS
            </span>
            <img src="https://i.postimg.cc/qRymx0VW/6686aa12-min.png" alt="Bono 1 — Recetario de Postres" className="w-full h-auto object-contain" data-id="element-79" />
            <div className="p-5" data-id="element-80">
              <h3 className="text-[15px] font-bold mb-2" data-id="element-81">
                Recetario de Postres Sin Gluten
              </h3>
              <p className="text-[13px] text-white/60 leading-[1.6] mb-3" data-id="element-82">
                15 postres italianos clásicos adaptados con El Método
                Italiano™. Tiramisú, panna cotta y más — sin gluten, con todo
                el sabor.
              </p>
              <div className="text-[12px] text-white/35 line-through" data-id="element-83">
                Valor: USD $29
              </div>
            </div>
          </div>

          <div className="bg-carbon border border-oro/15 rounded-md overflow-hidden relative transition-all duration-300 hover:-translate-y-1.5 hover:border-oro/50" data-id="element-84">
            <span className="absolute top-3 right-3 bg-verde text-white font-montserrat font-black text-[11px] tracking-[1px] px-2.5 py-1 rounded-sm z-10" data-id="element-85">
              HOY GRATIS
            </span>
            <img src="https://i.postimg.cc/26hH7mRG/69a62018-min.png" alt="Bono 2 — Guía de Almacenamiento" className="w-full h-auto object-contain" data-id="element-86" />
            <div className="p-5" data-id="element-87">
              <h3 className="text-[15px] font-bold mb-2" data-id="element-88">
                Guía de Almacenamiento Profesional
              </h3>
              <p className="text-[13px] text-white/60 leading-[1.6] mb-3" data-id="element-89">
                Cómo guardar pasta fresca y seca para que dure semanas sin
                perder textura. El secreto que te ahorra tiempo y dinero cada
                semana.
              </p>
              <div className="text-[12px] text-white/35 line-through" data-id="element-90">
                Valor: USD $19
              </div>
            </div>
          </div>

          <div className="bg-carbon border border-oro/15 rounded-md overflow-hidden relative transition-all duration-300 hover:-translate-y-1.5 hover:border-oro/50" data-id="element-91">
            <span className="absolute top-3 right-3 bg-verde text-white font-montserrat font-black text-[11px] tracking-[1px] px-2.5 py-1 rounded-sm z-10" data-id="element-92">
              HOY GRATIS
            </span>
            <img src="https://i.postimg.cc/fb62dyF8/6b40992c-min.png" alt="Bono 3 — Comunidad Privada" className="w-full h-auto object-contain" data-id="element-93" />
            <div className="p-5" data-id="element-94">
              <h3 className="text-[15px] font-bold mb-2" data-id="element-95">
                Acceso a la Comunidad Privada
              </h3>
              <p className="text-[13px] text-white/60 leading-[1.6] mb-3" data-id="element-96">
                Únete al grupo exclusivo donde resolvemos dudas, compartimos
                resultados y seguimos aprendiendo juntos. Hugo responde
                personalmente.
              </p>
              <div className="text-[12px] text-white/35 line-through" data-id="element-97">
                Valor: USD $39
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12 p-7 bg-oro/5 border border-oro/20 rounded-md max-w-[560px] mx-auto" data-id="element-98">
          <p className="text-[13px] text-white/50 mb-2" data-id="element-99">
            Valor total del paquete completo
          </p>
          <p className="font-montserrat text-[32px] font-black text-white/30 line-through" data-id="element-100">
            USD $207
          </p>
          <p className="font-montserrat text-[52px] font-black text-oro-claro leading-none" data-id="element-101">
            USD $12
          </p>
          <p className="text-[12px] text-oro mt-1.5" data-id="element-102">
            Precio de lanzamiento limitado
          </p>
        </div>
      </div>
    </section>;
}